export enum UserProductActivityCd {
    SettingUp,
    Active,
    TurnedOff,
    Stopped
}

export enum GeneralStatusCd {
    Active = 1,
    Terminated = 3
}

export enum ProductTypeCd {
    CryptoMiner = 1,
    GPU = 2,
    RIG = 3
}

export enum UserTransactionTypeCd {
    Deposit = 1,
    Withdraw = 2,
    PurchaseUserProduct = 3,
    MarketplacePayout = 4,
}

export enum UserProductOwnershipTypeCd {
    Dedicated,
    Shared
}

export enum UserTransactionStageCd {
    WaitingForPayment,
    Paid,
    Processed
}
